<template>
  <div>
    <div class="centered-column">
      <div class="container-header">
        <h3> {{ label.get('timesheet_report') }}</h3>
      </div>
      <div class="white-card timesheet-report-preference">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get('preference') }}</label>
          </div>
        </div>
        <div class="content-wrapper">
          <div class="field-wrap d-flex justify-content-between align-items-center">
            <div class="check-wrapper switch-wrapper">
              <b-form-checkbox
                  v-model="payrollEmail"
                  @change="changePayrollEmail"
              >
                {{ label.get('timesheet_report_email_report') }}
              </b-form-checkbox>
              <p class="disclaimer">
                {{ label.get('timesheet_report_email_report_description') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="white-card" v-if="payrollEmail">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get('timesheet_report_payroll_period') }}</label>
          </div>
          <div class="action-buttons" v-if="saveChangesEnabled">
            <button
                class="update-btn cancel"
                type="button"
                @click="cancel"
            >
              <i class="atto atto-close-btn"/>
              {{ label.get('cancel') }}
            </button>
            <button
                class="update-btn save-changes"
                type="button"
                :disabled="disabledSubmitButton"
                @click="saveChanges"
            >
              <i class="atto atto-selected-tick"/>
              {{ label.get('save_changes') }}
            </button>
          </div>
        </div>
        <div
            class="content-wrapper payroll no-border"
            :class="{disabled: !payrollEmail}"
        >
          <div class="child-wrapper">
            <div class="field-wrap">
              <p class="label">
                {{ label.get('timesheet_report_payroll_period_workweek_start_day') }}
              </p>
              <select-dropdown-component
                  :value="startDay"
                  placeholder="Start Day"
                  :options="weekdays"
                  @onOptionSelected="onStartDaySelected"
              />
            </div>
            <div class="field-wrap">
              <p class="label">
                {{ label.get('timesheet_report_payroll_period_schedule') }}
              </p>
              <select-dropdown-component
                  :value="payrollSchedule"
                  placeholder="Schedule"
                  :options="schedules"
                  @onOptionSelected="onScheduleSelected"
              />
            </div>
            <div
                v-if="showFirstPayrollSelect"
                class="field-wrap"
            >
              <p
                  v-if="payrollSchedule !== SEMI_MONTHLY"
                  class="label"
              >
                {{ label.get('timesheet_report_payroll_period_payroll_closes_on') }}
              </p>
              <p
                  v-if="payrollSchedule === SEMI_MONTHLY"
                  class="label"
              >
                {{ label.get('timesheet_report_payroll_period_1st_payroll_closes') }}
              </p>
              <select-dropdown-component
                  :value="payrollFirstClose"
                  placeholder="Schedule"
                  :options="firstPayrollList"
                  @onOptionSelected="onFirstPayrollSelected"
              />
            </div>
            <div
                v-if="showSecondPayrollSelect"
                class="field-wrap"
            >
              <p
                  v-if="payrollSchedule !== SEMI_MONTHLY"
                  class="label"
              >
                {{ label.get('timesheet_report_payroll_period_payroll_closes_on') }}
              </p>
              <p
                  v-if="payrollSchedule === SEMI_MONTHLY"
                  class="label"
              >
                {{ label.get('timesheet_report_payroll_period_2st_payroll_closes') }}
              </p>
              <select-dropdown-component
                  :value="payrollSecondClose"
                  placeholder="Schedule"
                  :options="secondPayrollList"
                  @onOptionSelected="onSecondPayrollSelected"
              />
            </div>
            <div
                v-if="payrollSchedule === CUSTOM"
                class="field-wrap"
            >
              <p class="label">
                {{ label.get('timesheet_report_include_hours_for') }}
              </p>
              <select-dropdown-component
                  :value="payrollFirstClose"
                  placeholder="Schedule"
                  :options="weekdays"
                  @onOptionSelected="onFirstPayrollSelected"
              />
              <i class="atto atto-rdir-arrow-b subsequent-icon"/>
              <select-dropdown-component
                  :value="payrollSecondClose"
                  placeholder="Schedule"
                  :options="weekdays"
                  @onOptionSelected="onSecondPayrollSelected"
              />
            </div>
          </div>
        </div>
        <div class="info-wrapper" v-if="payrollEmail">
          <p
              v-if="payrollSchedule === WEEKLY"
              class="info"
              v-html="label.get('timesheet_report_payroll_weekly', {firstLabel: firstLabel, secondLabel: secondLabel})"
          />
          <p
              v-if="payrollSchedule === BI_WEEKLY"
              class="info"
              v-html="label.get('timesheet_report_payroll_bi_weekly', {firstLabel: firstLabel, secondLabel: secondLabel})"
          />
          <p
              v-if="payrollSchedule === SEMI_MONTHLY"
              class="info"
              v-html="label.get('timesheet_report_payroll_semi_monthly', {firstLabel: firstLabel, secondLabel: secondLabel})"
          />
          <p
              v-if="payrollSchedule === MONTHLY"
              class="info"
              v-html="label.get('timesheet_report_payroll_monthly', {firstLabel: firstLabel, secondLabel: secondLabel})"
          />
          <p
              v-if="payrollSchedule === CUSTOM"
              class="info"
              v-html="label.get('timesheet_report_payroll_custom', {firstLabel: firstLabel})"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectDropdownComponent from '../../../shared/components/SelectDropdownComponent';
import CompanyService from "../company/services/CompanyService";
import UtilsService from "../../../shared/services/UtilsService";

export default {
  name: "TimesheetReportComponent",
  components: {
    SelectDropdownComponent
  },
  data() {
    const payrollSchedule = this.$store.state.companySettings.payroll_schedule;
    let payrollFistClose = this.$store.state.companySettings.payroll_first_close;
    const payrollSecondClose = this.$store.state.companySettings.payroll_second_close;
    if(payrollSchedule === 2) {
      const biWeeklyDate = this.$moment(payrollFistClose + '-' + payrollSecondClose, 'D-M');
      payrollFistClose = biWeeklyDate.format('DD-MM');
    }
    return {
      saveChangesEnabled: false,
      payrollEmail: this.$store.state.companySettings.payroll_email,
      startDay: this.$store.state.companySettings.start_day,
      weekdays: UtilsService.getMappedWeekdays(this.$store.state.weekdays),
      payrollSchedule: payrollSchedule,
      schedules: UtilsService.getMappedPayrollSchedulers(this.$store.state.payrollSchedulers),
      payrollFirstClose: payrollFistClose,
      payrollSecondClose: payrollSecondClose,
      firstPayrollList: [],
      secondPayrollList: [],
      showFirstPayrollSelect: false,
      showSecondPayrollSelect: false,
      showThirdPayrollSelect: false,
      firstLabel: '',
      secondLabel: '',
      WEEKLY: 1,
      BI_WEEKLY: 2,
      SEMI_MONTHLY: 3,
      MONTHLY: 4,
      CUSTOM: 5,
      disabledSubmitButton: false
    }
  },
  mounted() {
    this.firstPayrollList = this.getFirstPayrollList();
    this.secondPayrollList = this.getSecondPayrollList();
    this.showFirstPayrollSelectItem();
    this.showSecondPayrollSelectItem();
    this.fillFirstAndSecondLabels();
  },
  methods: {
    changePayrollEmail() {
      /*this.saveChangesEnabled = true;*/
    },
    onStartDaySelected(item) {
      this.startDay = item.value;
      this.saveChangesEnabled = true;
      this.disabledSubmitButton = false;
      this.firstPayrollList = this.getFirstPayrollList();
      this.secondPayrollList = this.getSecondPayrollList();
      this.fillFirstAndSecondLabels();
    },
    onScheduleSelected(item) {
      this.payrollSchedule = item.value;
      this.saveChangesEnabled = true;
      this.showFirstPayrollSelect = false;
      this.showSecondPayrollSelect = false;

      this.firstPayrollList = this.getFirstPayrollList();
      this.secondPayrollList = this.getSecondPayrollList();
      if (item.value === this.WEEKLY) {
        this.payrollFirstClose = null;
        this.payrollSecondClose = null;
      }
      else if (item.value === this.SEMI_MONTHLY) {
        if (item.value === this.SEMI_MONTHLY) {
          this.payrollFirstClose = 15;
          this.payrollSecondClose = 31;
        }
      }
      else if (item.value === this.MONTHLY) {
        this.payrollFirstClose = 31;
        this.payrollSecondClose = null;
      }
      else if (item.value === this.CUSTOM) {
        this.payrollFirstClose = 1;
        this.payrollSecondClose = 5;
      }

      this.showFirstPayrollSelectItem();
      this.showSecondPayrollSelectItem();

      this.fillFirstAndSecondLabels();
    },
    onFirstPayrollSelected(item) {
      this.payrollFirstClose = item.value;
      this.saveChangesEnabled = true;
      this.fillFirstAndSecondLabels();
    },
    onSecondPayrollSelected(item) {
      this.payrollSecondClose = item.value;
      this.saveChangesEnabled = true;
      this.fillFirstAndSecondLabels();
    },
    showFirstPayrollSelectItem() {
      if (this.payrollSchedule !== this.WEEKLY && this.payrollSchedule !== this.CUSTOM) {
        this.showFirstPayrollSelect = true;
      }
    },
    showSecondPayrollSelectItem() {
      if (this.payrollSchedule !== this.CUSTOM && (this.payrollSchedule === this.CUSTOM || this.payrollSchedule === this.SEMI_MONTHLY)) {
        this.showSecondPayrollSelect = true;
      }
    },
    saveChanges() {
      this.disabledSubmitButton = false;
      this.$store.commit('showLoading');
      this.$store.state.companySettings.start_day = this.startDay;
      this.$store.state.companySettings.payroll_email = this.payrollEmail;
      this.$store.state.companySettings.payroll_schedule = this.payrollSchedule;
      this.$store.state.companySettings.payroll_first_close = this.payrollFirstClose;
      this.$store.state.companySettings.payroll_second_close = this.payrollSecondClose;
      if(this.payrollSchedule === this.BI_WEEKLY) {
        const [day, month] = this.payrollFirstClose.split('-');
        this.$store.state.companySettings.payroll_first_close = parseInt(day);
        this.$store.state.companySettings.payroll_second_close = parseInt(month);
      }
      CompanyService.updateCompanySettings(this.$store.state.companySettings).then((response) => {
        this.$store.commit('hideLoading');
        this.saveChangesEnabled = false;
        this.$awn.success(response.data.message);
      }).catch(() => {
        this.$store.commit('hideLoading');
        this.saveChangesEnabled = true;
        this.disabledSubmitButton = false;
      });
    },
    getFirstPayrollList() {
      if (this.payrollSchedule === this.SEMI_MONTHLY || this.payrollSchedule === this.MONTHLY) {
        return this.getDaysOfMonthList();
      }
      if (this.payrollSchedule === this.BI_WEEKLY) {
        const thisPayrollVal = this.$moment().day(this.startDay).add(-1, 'day');
        return this.fillFirstPayrollSelector(thisPayrollVal, true);
      }
      return [];
    },
    getSecondPayrollList() {
      if (this.payrollSchedule === this.SEMI_MONTHLY) {
        return this.getDaysOfMonthList();
      }
      return [];
    },
    fillFirstPayrollSelector(date, isFromOnChange = false) {
      let list = [];
      if (date < this.$moment() && isFromOnChange) {
        date.add(1, 'weeks');
      }
      if (date.diff(this.$moment(), 'days') >= 7) {
        date.add(-7, 'day');
      }

      let firstItem = null;
      let isSelected = false;
      for (let j = 0; j <= 2; j++) {
        if (j === 0) {
          firstItem = date.clone();
        }
        if (this.payrollFirstClose === date.format('DD-MM')) {
          isSelected = true;
        }
        list.push({
          value: date.format('DD-MM'),
          label: date.format('Do MMM').toString()
        });
        date.add(7, 'day');
      }

      if (!isSelected) {
        this.payrollFirstClose = firstItem.format('DD-MM');
        this.payrollSecondClose = firstItem.month();
      }

      return list;
    },
    fillFirstAndSecondLabels() {
      if (this.payrollSchedule === this.WEEKLY || this.payrollSchedule === this.BI_WEEKLY) {
        const weekdayItem = this.weekdays.find((item) => {
          return item.value === this.startDay
        });
        this.firstLabel = weekdayItem.label;
        this.secondLabel = this.$moment().day(this.startDay).add(-1, 'day').format('dddd');
      } else if (this.payrollSchedule === this.SEMI_MONTHLY) {
        const daysOfMonth = this.getDaysOfMonthList();
        const lastIndexOfList = daysOfMonth.length - 1;

        const firstPayrollObject = daysOfMonth.find((item) => {
          return item.value === this.payrollFirstClose
        });
        const secondPayrollObject = daysOfMonth.find((item) => {
          return item.value === this.payrollSecondClose
        });
        let firstPayrollIndex = daysOfMonth.indexOf(firstPayrollObject);
        let secondPayrollIndex = daysOfMonth.indexOf(secondPayrollObject);
        if (firstPayrollIndex + 1 > lastIndexOfList) {
          firstPayrollIndex = 0;
        } else {
          firstPayrollIndex++;
        }
        if (secondPayrollIndex + 1 > lastIndexOfList) {
          secondPayrollIndex = 0;
        } else {
          secondPayrollIndex++;
        }

        this.firstLabel = daysOfMonth[secondPayrollIndex].label + ' to ' + firstPayrollObject.label;
        this.secondLabel = daysOfMonth[firstPayrollIndex].label + ' to ' + secondPayrollObject.label;
      } else if (this.payrollSchedule === this.MONTHLY) {
        const daysOfMonth = this.getDaysOfMonthList();
        const firstPayrollObject = daysOfMonth.find((item) => {
          return item.value === this.payrollFirstClose
        });
        let firstPayrollIndex = daysOfMonth.indexOf(firstPayrollObject);
        if (firstPayrollIndex + 1 > daysOfMonth.length - 1) {
          firstPayrollIndex = 0;
        } else {
          firstPayrollIndex++;
        }
        this.firstLabel = daysOfMonth[firstPayrollIndex].label;
        this.secondLabel = firstPayrollObject.label;
      } else {
        let secondPayrollObject = this.weekdays.find((item) => {
          return item.value === parseInt(this.payrollSecondClose);
        });
        if (secondPayrollObject === null || secondPayrollObject === undefined) {
          secondPayrollObject = this.weekdays[0];
        }
        let secondPayrollIndex = this.weekdays.indexOf(secondPayrollObject);
        if (secondPayrollIndex + 1 > this.weekdays.length - 1) {
          secondPayrollIndex = 0;
        } else {
          secondPayrollIndex++;
        }

        this.firstLabel = this.weekdays[secondPayrollIndex].label;
      }
    },
    getDaysOfMonthList() {
      return [
        {value: 1, label: '1st'},
        {value: 2, label: '2nd'},
        {value: 3, label: '3rd'},
        {value: 4, label: '4th'},
        {value: 5, label: '5th'},
        {value: 6, label: '6th'},
        {value: 7, label: '7th'},
        {value: 8, label: '8th'},
        {value: 9, label: '9th'},
        {value: 10, label: '10th'},
        {value: 11, label: '11th'},
        {value: 12, label: '12th'},
        {value: 13, label: '13th'},
        {value: 14, label: '14th'},
        {value: 15, label: '15th'},
        {value: 16, label: '16th'},
        {value: 17, label: '17th'},
        {value: 18, label: '18th'},
        {value: 19, label: '19th'},
        {value: 20, label: '20th'},
        {value: 21, label: '21st'},
        {value: 22, label: '22nd'},
        {value: 23, label: '23rd'},
        {value: 24, label: '24th'},
        {value: 25, label: '25th'},
        {value: 26, label: '26th'},
        {value: 27, label: '27th'},
        {value: 28, label: '28th'},
        {value: 29, label: '29th'},
        {value: 30, label: '30th'},
        {value: 31, label: this.label.get('last_day_of_month')}
      ];
    },
    cancel() {
      this.startDay = this.$store.state.companySettings.start_day;
      this.payrollSchedule = this.$store.state.companySettings.payroll_schedule;
      this.payrollFirstClose = this.$store.state.companySettings.payroll_first_close;
      this.payrollSecondClose = this.$store.state.companySettings.payroll_second_close;
      this.saveChangesEnabled = false;
    }
  }
}
</script>

<style lang="scss">
.toggle-dep {
  padding-bottom: 40px;
  border-bottom: 2px solid $atto-light-grey;
}

.payroll {
  position: relative;
}

.disabled {
  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
  }

  .section-headtitle,
  .child-wrapper p.info,
  .child-wrapper .field-wrap .atto-select .select-heading span.selected,
  .child-wrapper .field-wrap p {
    color: $atto-dark-grey !important;
  }

  .child-wrapper .field-wrap i.subsequent-icon,
  .child-wrapper .field-wrap .atto-select .select-heading i {
    color: #f7f7f7;
  }

  .child-wrapper .field-wrap .atto-select .select-heading {
    border-color: #fafafa;
  }
}

.field-wrap {
  i.subsequent-icon {
    width: 24px;
    height: 24px;
    color: $atto-dark-grey;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin: 0 16px;
  }
}

body.de {
  .child-wrapper .field-wrap p {
    width: 220px;
  }
}

body.es {
  .child-wrapper .field-wrap p {
    width: 220px;
  }
}
</style>

<style lang="scss" scoped>
.check-wrapper .custom-checkbox .custom-control-label {
  font-weight: $roboto-regular;
}

.timesheet-report-preference {
  p.disclaimer {
    max-width: 640px;
    width: 100%;
    color: #666666;
    margin-top: 4px;
  }
}

.info-wrapper {
  width: 100%;
  background-color: $atto-grey;
  padding: 40px;
  height: 104px;
  display: flex;
  align-items: center;

  p.info {
    margin-bottom: 0;
    font: $roboto-regular 0.9375rem/1.25rem $roboto-font;
    color: $atto-font-color;
    display: block;
    align-items: center;
    justify-content: flex-start;

    strong {
      font-weight: 500;
      margin-left: 4px;
    }

    &:before {
      content: '';
      width: 16px;
      height: 16px;
      display: inline-block;
      background: url('~@assets/images/info-green.svg') no-repeat center;
      margin-right: 8px;
      position: relative;
      top: 2px;
    }
  }
}
</style>

